(function () {

  function initFurCartDrawer() {

    const drawer =
      document.querySelector(
        '[data-fur-cart-drawer]'
      );

    const overlay =
      document.querySelector(
        '[data-fur-cart-overlay]'
      );


    if (
      !drawer ||
      !overlay
    ) {
      return;
    }


    if (
      drawer.dataset.furCartInitialized ===
      'true'
    ) {
      return;
    }


    drawer.dataset.furCartInitialized =
      'true';


    /* =====================================================
       SHOPIFY ROOT
    ===================================================== */

    function getShopifyRoot() {

      return (
        window.Shopify?.routes?.root ||
        '/'
      );

    }


    /* =====================================================
       OPEN DRAWER
    ===================================================== */

    function openCart() {

      drawer.classList.add(
        'is-open'
      );


      overlay.classList.add(
        'is-open'
      );


      drawer.setAttribute(
        'aria-hidden',
        'false'
      );


      overlay.setAttribute(
        'aria-hidden',
        'false'
      );


      document.documentElement
        .classList.add(
          'fur-cart-open'
        );


      document.body.classList.add(
        'fur-cart-open'
      );

    }


    /* =====================================================
       CLOSE DRAWER
    ===================================================== */

    function closeCart() {

      drawer.classList.remove(
        'is-open'
      );


      overlay.classList.remove(
        'is-open'
      );


      drawer.setAttribute(
        'aria-hidden',
        'true'
      );


      overlay.setAttribute(
        'aria-hidden',
        'true'
      );


      document.documentElement
        .classList.remove(
          'fur-cart-open'
        );


      document.body.classList.remove(
        'fur-cart-open'
      );

    }


    /* =====================================================
       GLOBAL ACCESS
    ===================================================== */

    window.FurCartDrawer = {
      open: openCart,
      close: closeCart,
      refresh: refreshCart
    };


    /* =====================================================
       CLOSE BUTTON
    ===================================================== */

    drawer.addEventListener(
      'click',
      function (event) {

        const closeButton =
          event.target.closest(
            '[data-fur-cart-close]'
          );


        if (!closeButton) {
          return;
        }


        event.preventDefault();


        closeCart();

      }
    );


    /* =====================================================
       OVERLAY CLOSE
    ===================================================== */

    overlay.addEventListener(
      'click',
      function () {

        closeCart();

      }
    );


    /* =====================================================
       ESCAPE CLOSE
    ===================================================== */

    document.addEventListener(
      'keydown',
      function (event) {

        if (
          event.key ===
            'Escape' &&
          drawer.classList.contains(
            'is-open'
          )
        ) {

          closeCart();

        }

      }
    );


    /* =====================================================
       HEADER BAG CLICK
    ===================================================== */

    document.addEventListener(
      'click',
      function (event) {

        const bagLink =
          event.target.closest(
            '[data-fur-cart-toggle]'
          );


        if (!bagLink) {
          return;
        }


        event.preventDefault();


        openCart();

      }
    );


    /* =====================================================
       GET CART
    ===================================================== */

    async function getCart() {

      const response =
        await fetch(
          getShopifyRoot() +
          'cart.js',
          {
            headers: {
              Accept:
                'application/json'
            }
          }
        );


      if (!response.ok) {

        throw new Error(
          'Unable to load cart.'
        );

      }


      return response.json();

    }


    /* =====================================================
       CHANGE CART ITEM
    ===================================================== */

    async function changeItem(
      line,
      quantity
    ) {

      const response =
        await fetch(
          getShopifyRoot() +
          'cart/change.js',
          {
            method: 'POST',

            headers: {
              'Content-Type':
                'application/json',

              Accept:
                'application/json'
            },

            body:
              JSON.stringify({
                line: line,
                quantity: quantity
              })
          }
        );


      const data =
        await response.json();


      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to update cart.'
        );

      }


      return data;

    }


    /* =====================================================
       UPDATE HEADER BAG COUNT
    ===================================================== */

    function updateHeaderCount(
      cart
    ) {

      const headerCounts =
        document.querySelectorAll(
          '[data-fur-header-cart-count]'
        );


      headerCounts.forEach(
        function (element) {

          element.textContent =
            cart.item_count;

        }
      );

    }


    /* =====================================================
       MONEY FORMAT
    ===================================================== */

    function formatMoney(cents) {

      if (
        window.Shopify &&
        typeof window.Shopify.formatMoney ===
        'function'
      ) {

        return window.Shopify.formatMoney(
          cents,
          window.theme?.moneyFormat ||
          '${{amount}}'
        );

      }


      const currency =
        window.Shopify?.currency?.active ||
        'USD';


      try {

        return new Intl.NumberFormat(
          document.documentElement.lang ||
          'en',
          {
            style: 'currency',
            currency: currency
          }
        ).format(
          cents / 100
        );

      } catch (error) {

        return (
          (cents / 100).toFixed(2) +
          ' ' +
          currency
        );

      }

    }


    /* =====================================================
       ESCAPE HTML
    ===================================================== */

    function escapeHtml(value) {

      return String(
        value ?? ''
      )
        .replace(
          /&/g,
          '&amp;'
        )
        .replace(
          /</g,
          '&lt;'
        )
        .replace(
          />/g,
          '&gt;'
        )
        .replace(
          /"/g,
          '&quot;'
        )
        .replace(
          /'/g,
          '&#039;'
        );

    }


    /* =====================================================
       CART ITEM IMAGE
    ===================================================== */

    function getItemImage(item) {

      if (!item.image) {
        return '';
      }


      return `
        <a
          href="${escapeHtml(item.url)}"
          class="fur-cart-item__image-link"
        >
          <img
            src="${escapeHtml(item.image)}"
            alt="${escapeHtml(item.product_title)}"
            class="fur-cart-item__image"
            loading="lazy"
          >
        </a>
      `;

    }


    /* =====================================================
       CART ITEM OPTIONS
    ===================================================== */

    function getItemOptions(item) {

      if (
        !item.options_with_values ||
        !item.options_with_values.length
      ) {
        return '';
      }


      const validOptions =
        item.options_with_values.filter(
          function (option) {

            return (
              option.value &&
              option.value !==
                'Default Title'
            );

          }
        );


      if (!validOptions.length) {
        return '';
      }


      const options =
        validOptions
          .map(
            function (option) {

              return `
                <span
                  class="fur-cart-item__variant-option"
                >
                  [
                  ${escapeHtml(option.value)}
                  ]
                </span>
              `;

            }
          )
          .join('');


      return `
        <div
          class="fur-cart-item__variant"
        >
          ${options}
        </div>
      `;

    }


    /* =====================================================
       CART ITEM PRICE
    ===================================================== */

    function getItemPrice(item) {

      let compare = '';


      if (
        item.original_line_price >
        item.final_line_price
      ) {

        compare = `
          <s
            class="fur-cart-item__compare-price"
          >
            ${formatMoney(
              item.original_line_price
            )}
          </s>
        `;

      }


      return `
        <div
          class="fur-cart-item__price"
          data-fur-cart-item-price
        >
          ${compare}

          <span
            class="fur-cart-item__current-price"
          >
            ${formatMoney(
              item.final_line_price
            )}
          </span>
        </div>
      `;

    }


    /* =====================================================
       BUILD CART ITEM
    ===================================================== */

    function buildCartItem(
      item,
      index
    ) {

      const line =
        index + 1;


      return `
        <article
          class="fur-cart-item"
          data-fur-cart-item
          data-line="${line}"
          data-key="${escapeHtml(item.key)}"
        >

          ${getItemImage(item)}

          <div
            class="fur-cart-item__info"
          >

            <div
              class="fur-cart-item__top"
            >

              <div
                class="fur-cart-item__title-area"
              >

                <a
                  href="${escapeHtml(item.url)}"
                  class="fur-cart-item__title"
                >
                  ${escapeHtml(
                    item.product_title
                  )}
                </a>

                ${getItemOptions(item)}

              </div>


              ${getItemPrice(item)}

            </div>


            <div
              class="fur-cart-item__bottom"
            >

              <div
                class="fur-cart-item__quantity"
              >

                <span
                  class="fur-cart-item__quantity-bracket"
                >
                  [
                </span>

                <button
                  type="button"
                  class="fur-cart-item__quantity-button"
                  data-fur-cart-minus
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <span
                  class="fur-cart-item__quantity-value"
                  data-fur-cart-quantity
                >
                  ${item.quantity}
                </span>

                <button
                  type="button"
                  class="fur-cart-item__quantity-button"
                  data-fur-cart-plus
                  aria-label="Increase quantity"
                >
                  +
                </button>

                <span
                  class="fur-cart-item__quantity-bracket"
                >
                  ]
                </span>

              </div>


              <div
                class="fur-cart-item__actions"
              >

                <button
                  type="button"
                  class="fur-cart-item__action"
                  data-fur-cart-remove
                >
                  REMOVE
                </button>

                <button
                  type="button"
                  class="fur-cart-item__action"
                  data-fur-cart-favorite
                >
                  ADD TO FAVORITES
                </button>

              </div>

            </div>

          </div>

        </article>
      `;

    }


    /* =====================================================
       EMPTY CART
    ===================================================== */

    function buildEmptyCart() {

      return `
        <div
          class="fur-cart-drawer__empty"
        >

          <div
            class="fur-cart-drawer__empty-title"
          >
            YOUR BAG IS EMPTY
          </div>

          <a
            href="${getShopifyRoot()}collections/all"
            class="fur-cart-drawer__continue"
          >
            [
            CONTINUE SHOPPING
            ]
          </a>

        </div>
      `;

    }


    /* =====================================================
       RECOMMENDATION CARD
    ===================================================== */

    function buildCartRecommendationCard(
      product
    ) {

      let image = '';


      if (
        product.featured_image
      ) {

        if (
          typeof product.featured_image ===
          'string'
        ) {

          image =
            product.featured_image;

        } else if (
          product.featured_image.src
        ) {

          image =
            product.featured_image.src;

        }

      }


      if (
        !image &&
        product.images &&
        product.images.length
      ) {

        const firstImage =
          product.images[0];


        if (
          typeof firstImage ===
          'string'
        ) {

          image =
            firstImage;

        } else if (
          firstImage.src
        ) {

          image =
            firstImage.src;

        }

      }


      const productUrl =
        product.url ||
        (
          product.handle
            ? getShopifyRoot() +
              'products/' +
              product.handle
            : '#'
        );


      return `
        <a
          href="${escapeHtml(productUrl)}"
          class="fur-cart-recommendation-card"
        >

          <div
            class="fur-cart-recommendation-card__media"
          >

            ${
              image
                ? `
                  <img
                    src="${escapeHtml(image)}"
                    alt="${escapeHtml(product.title)}"
                    class="fur-cart-recommendation-card__image"
                    loading="lazy"
                  >
                `
                : ''
            }

          </div>


          <div
            class="fur-cart-recommendation-card__info"
          >

            <div
              class="fur-cart-recommendation-card__title"
            >
              ${escapeHtml(product.title)}
            </div>


            <div
              class="fur-cart-recommendation-card__price"
            >
              ${formatMoney(product.price)}
            </div>

          </div>

        </a>
      `;

    }


    /* =====================================================
       LOAD CART RECOMMENDATIONS
    ===================================================== */

    async function loadCartRecommendations(
      cart
    ) {

      const recommendationsTrack =
        drawer.querySelector(
          '[data-fur-cart-recommendations]'
        );


      if (!recommendationsTrack) {
        return;
      }


      recommendationsTrack.innerHTML =
        '';


      if (
        !cart ||
        !cart.items ||
        !cart.items.length
      ) {
        return;
      }


      const recommendationSection =
        recommendationsTrack.closest(
          '.fur-cart-drawer__recommendations'
        );


      const productId =
        cart.items[0].product_id;


      if (!productId) {

        if (recommendationSection) {

          recommendationSection.style.display =
            'none';

        }


        return;

      }


      try {

        const root =
          getShopifyRoot();


        const url =
          root +
          'recommendations/products.json' +
          '?product_id=' +
          encodeURIComponent(productId) +
          '&limit=6' +
          '&intent=related';


        const response =
          await fetch(
            url,
            {
              headers: {
                Accept:
                  'application/json'
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            'Unable to load cart recommendations.'
          );

        }


        const data =
          await response.json();


        const products =
          data.products || [];


        /*
         * Don't show the exact same product
         * already used as recommendation source.
         */

        const filteredProducts =
          products.filter(
            function (product) {

              return (
                Number(product.id) !==
                Number(productId)
              );

            }
          );


        if (!filteredProducts.length) {

          if (recommendationSection) {

            recommendationSection.style.display =
              'none';

          }


          return;

        }


        if (recommendationSection) {

          recommendationSection.style.display =
            '';

        }


        recommendationsTrack.innerHTML =
          filteredProducts
            .slice(0, 6)
            .map(
              function (product) {

                return buildCartRecommendationCard(
                  product
                );

              }
            )
            .join('');


      } catch (error) {

        console.error(
          'THE FUR CART RECOMMENDATIONS:',
          error
        );


        if (recommendationSection) {

          recommendationSection.style.display =
            'none';

        }

      }

    }


    /* =====================================================
       RENDER CART
    ===================================================== */

    function renderCart(cart) {

      const content =
        drawer.querySelector(
          '[data-fur-cart-content]'
        );


      const count =
        drawer.querySelector(
          '[data-fur-cart-count]'
        );


      if (count) {

        count.textContent =
          cart.item_count;

      }


      updateHeaderCount(
        cart
      );


      if (!content) {
        return;
      }


      if (
        cart.item_count === 0
      ) {

        content.innerHTML =
          buildEmptyCart();


        return;

      }


      const itemsHtml =
        cart.items
          .map(
            buildCartItem
          )
          .join('');


      content.innerHTML = `

        <div
          class="fur-cart-drawer__items"
          data-fur-cart-items
        >
          ${itemsHtml}
        </div>


        <div
          class="fur-cart-drawer__recommendations"
        >

          <div
            class="fur-cart-drawer__recommendations-header"
          >

            <span>
              YOU MAY ALSO LIKE
            </span>

            <span
              class="fur-cart-drawer__recommendations-line"
              aria-hidden="true"
            ></span>

          </div>


          <div
            class="fur-cart-drawer__recommendations-track"
            data-fur-cart-recommendations
          ></div>

        </div>


        <div
          class="fur-cart-drawer__summary"
        >

          <div
            class="fur-cart-drawer__subtotal-row"
          >

            <span
              class="fur-cart-drawer__subtotal-label"
            >
              SUBTOTAL:
            </span>


            <span
              class="fur-cart-drawer__subtotal-value"
              data-fur-cart-subtotal
            >
              [
              ${formatMoney(
                cart.total_price
              )}
              ]
            </span>

          </div>


          <form
            action="${getShopifyRoot()}cart"
            method="post"
            class="fur-cart-drawer__checkout-form"
          >

            <button
              type="submit"
              name="checkout"
              class="fur-cart-drawer__checkout"
            >
              [
              CHECKOUT
              ]
            </button>

          </form>


          <div
            class="fur-cart-drawer__footer-notes"
          >

            <div
              class="fur-cart-drawer__footer-note"
            >
              TAXES, SHIPPING, AND
              <span>
                DISCOUNTS
              </span>
              ARE CALCULATED WITH
              <span>
                GIFT CARDS
              </span>
              APPLIED AT CHECKOUT
            </div>


            <div
              class="
                fur-cart-drawer__footer-note
                fur-cart-drawer__footer-note--right
              "
            >
              PROMOTIONAL CODES

              <span>
                AT CHECKOUT
              </span>

            </div>

          </div>

        </div>
      `;


      /*
       * Load recommendations after
       * the recommendation container exists.
       */

      loadCartRecommendations(
        cart
      );

    }


    /* =====================================================
       REFRESH CART
    ===================================================== */

    async function refreshCart() {

      try {

        const cart =
          await getCart();


        renderCart(
          cart
        );


        return cart;


      } catch (error) {

        console.error(
          'THE FUR CART:',
          error
        );


        return null;

      }

    }


    /* =====================================================
       QUANTITY / REMOVE
    ===================================================== */

    drawer.addEventListener(
      'click',
      async function (event) {

        const plus =
          event.target.closest(
            '[data-fur-cart-plus]'
          );


        const minus =
          event.target.closest(
            '[data-fur-cart-minus]'
          );


        const remove =
          event.target.closest(
            '[data-fur-cart-remove]'
          );


        if (
          !plus &&
          !minus &&
          !remove
        ) {
          return;
        }


        const item =
          event.target.closest(
            '[data-fur-cart-item]'
          );


        if (!item) {
          return;
        }


        const line =
          parseInt(
            item.dataset.line,
            10
          );


        if (
          Number.isNaN(line)
        ) {
          return;
        }


        const quantityElement =
          item.querySelector(
            '[data-fur-cart-quantity]'
          );


        const currentQuantity =
          parseInt(
            quantityElement?.textContent ||
            '1',
            10
          );


        let newQuantity =
          currentQuantity;


        if (plus) {

          newQuantity =
            currentQuantity + 1;

        }


        if (minus) {

          newQuantity =
            Math.max(
              0,
              currentQuantity - 1
            );

        }


        if (remove) {

          newQuantity = 0;

        }


        item.classList.add(
          'is-updating'
        );


        try {

          const cart =
            await changeItem(
              line,
              newQuantity
            );


          renderCart(
            cart
          );


        } catch (error) {

          console.error(
            'THE FUR CART:',
            error
          );


          item.classList.remove(
            'is-updating'
          );

        }

      }
    );


    /* =====================================================
       OPEN AFTER ADD TO BAG
    ===================================================== */

    document.addEventListener(
      'fur:cart-updated',
      async function () {

        await refreshCart();


        openCart();

      }
    );


    /* =====================================================
       INITIAL CART
    ===================================================== */

    refreshCart();

  }


  /* =======================================================
     NORMAL LOAD
  ======================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initFurCartDrawer
    );

  } else {

    initFurCartDrawer();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function () {

      const drawer =
        document.querySelector(
          '[data-fur-cart-drawer]'
        );


      if (drawer) {

        delete drawer.dataset
          .furCartInitialized;

      }


      initFurCartDrawer();

    }
  );

})();